import BannerPC from '@rebuild/materials/shared/banner/BannerPC_HK09606.vue';

export const componentMap = {
	basic: BannerPC
};